import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 40px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;

  @media (max-width: 480px) {
    border-radius: 12px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 24px;
  text-align: center;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  background: #fff;
  border: 2px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease-in;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 52px;
  background: ${({ theme }) => theme.colors.primary.main};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease-in;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.primary.light};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.gray[100]};
    color: ${({ theme }) => theme.colors.gray[200]};
    cursor: not-allowed;
  }
`;

export const BackButton = styled.button`
  width: 100%;
  height: 52px;
  background: transparent;
  color: ${({ theme }) => theme.colors.primary.main};
  border: 2px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in;
  margin-top: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.primary.main};
    color: #fff;
  }
`;

export const Message = styled.p`
  font-size: 16px;
  color: ${({ theme, $error }) => $error ? theme.colors.danger.main : theme.colors.gray[900]};
  text-align: center;
  line-height: 1.6;
  margin-bottom: 24px;

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const InfoText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray[600]};
  text-align: center;
  line-height: 1.5;
  margin-bottom: 8px;
`;
